import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hzc2pb2q9s: FaireBrandEntity = {
  token: "b_hzc2pb2q9s",
  type: "brand",
  name: "The Cumin Club",
  avatarUrl:
    "https://cdn.faire.com/fastly/5cfcb0c377fcf74387744a918f2629d6299067bd16dd14ed121cbaa7fc28c38e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/75948b67b9c41a9c54358ebe5c4d07c3691799720e5b9d5dcaf1522e7317b008.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5cfcb0c377fcf74387744a918f2629d6299067bd16dd14ed121cbaa7fc28c38e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/75948b67b9c41a9c54358ebe5c4d07c3691799720e5b9d5dcaf1522e7317b008.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "We are on a mission to make it even easier to enjoy authentic dishes from across India.\n\nAll of our plant-based dishes are made in just 5 minutes with all-natural ingredients and zero preservatives, so you can feel good about what you’re eating. Our expert chefs ensure we are staying true to the origins of each dish by using locally sourced ingredients and authentic cooking methods. We are rooted in representation, with a focus on showcasing the incredible and diverse dishes from across India that you can’t find on shelves.\nUnlike other ready-to-eat meals, our dishes have a clean label with familiar ingredients and spices like lentils, rice, turmeric, and ginger. Enjoy with some rice or roti or mix it up by adding your own protein for an extra boost of nutrition!\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:44.583Z",
    importedBy: "entity-db-cli",
  },
};
